// modules
import { handleActions } from 'redux-actions'

// actions
import { setReferralPayerList } from 'src/store/modules/admin/referralPayer'

const initialState = {
  referralPayerList: []
}

export default handleActions(
  {
    [setReferralPayerList](state, { payload: referralPayerList }) {
      return {
        ...state,
        referralPayerList
      }
    }
  },
  initialState
)
